// Curated Don Donuts menu data sourced from public delivery menus
export const ORDER_LINKS = {
  doordash: "https://www.doordash.com/en/store/don-donuts-mcallen-25003561/61743548/",
  grubhub: "https://www.grubhub.com/restaurant/don-donuts-101-e-expressway-83-mcallen/6143144",
  orderOnline: "https://order.online/store/DonDonuts-28795256",
  facebook: "https://www.facebook.com/dondonutsrgv/",
  instagram: "https://www.instagram.com/dondonutsrgv/",
  phone: "tel:+19565027221",
  maps: "https://maps.google.com/?q=101+E+Expressway+83+McAllen+TX+78501",
};

export const FEATURED_DONUTS = [
  {
    name: "The Don",
    tag: "Signature",
    price: "$4.95",
    desc: "Our signature donut — sweet pink glaze and a rainbow of sprinkles. Iconic in every bite.",
    image: "https://www.studiomediaagency.com/marketing/donuts-marketing7.webp",
    color: "bg-[#FFE3EB]",
    accent: "text-[#FF6392]",
  },
  {
    name: "Ferrero",
    tag: "Bestseller",
    price: "$4.95",
    desc: "Nutella-glazed, crushed Ferrero Rocher and a thick chocolate-hazelnut drizzle.",
    image: "https://img.cdn4dd.com/p/fit=cover,width=1200,height=1200,format=auto,quality=90/media/photosV2/7be297e5-4679-4552-9dbb-98862f73f8e7-retina-large.jpeg",
    color: "bg-[#F4E7DC]",
    accent: "text-[#9A5B2B]",
  },
  {
    name: "Strawberry Cheesecake",
    tag: "Loved",
    price: "$4.95",
    desc: "Pillow-soft donut, cheesecake cream and ripe-strawberry topping. Pure dessert energy.",
    image: "https://img.cdn4dd.com/p/fit=cover,width=1200,height=1200,format=auto,quality=90/media/photosV2/b27fd745-1ee5-4bac-8238-acda277e8b09-retina-large.jpeg",
    color: "bg-[#FFD6DD]",
    accent: "text-[#C03A5A]",
  },
  {
    name: "Snickers",
    tag: "Caramel",
    price: "$4.95",
    desc: "Custard-filled, crispy caramelized sugar crust — crème brûlée meets candy bar.",
    image: "https://www.studiomediaagency.com/marketing/donuts-marketing2.webp",
    color: "bg-[#FFE6BE]",
    accent: "text-[#8A5A1B]",
  },
  {
    name: "Mazapan",
    tag: "RGV Roots",
    price: "$4.95",
    desc: "An ode to the candy aisle of our childhood — soft donut with a mazapan finish.",
    image: "https://www.studiomediaagency.com/marketing/donuts-marketing4.webp",
    color: "bg-[#FFF1C9]",
    accent: "text-[#A8761A]",
  },
  {
    name: "The Franz",
    tag: "Classic+",
    price: "$4.95",
    desc: "Nutella + whipped cream, fresh strawberries, a generous dusting of powdered sugar.",
    image: "https://www.studiomediaagency.com/marketing/donuts-marketing8.webp",
    color: "bg-[#FFE3EB]",
    accent: "text-[#FF6392]",
  },
];

export const BOXES = [
  { name: "Box of 4", price: "$17.60", desc: "Pick four. Share two. Eat the rest in the car.", count: 4 },
  { name: "Box of 6", price: "$25.30", desc: "Half a dozen mix-and-match flavors of pure joy.", count: 6 },
  { name: "Box of 9", price: "$35.20", desc: "Nine flavors. Group hug. Best week ever.", count: 9 },
  { name: "Special Box", price: "$14.85", desc: "3 Chocolate · 3 Glaze · 3 Sugar. Classic only.", count: 9 },
];

export const DRINKS = [
  { name: "Iced Coffee Crunch", price: "$7.69", desc: "Iced coffee with a snap-able chocolate top.", image: "https://www.studiomediaagency.com/marketing/donuts-marketing6.webp" },
  { name: "Nutella Frappé", price: "$6.55", desc: "Coffee + Nutella + whipped cream swirl.", image: "https://img.cdn4dd.com/p/fit=cover,width=1200,height=1200,format=auto,quality=70/media/photosV2/5e03ac91-62e6-4b23-b938-e75ec6196dee-retina-large.jpeg" },
  { name: "Oreo Frappé", price: "$6.55", desc: "Cookies & cream cold-blended bliss.", image: "https://img.cdn4dd.com/p/fit=cover,width=1200,height=1200,format=auto,quality=70/media/photosV2/d26287d1-a097-4644-8fbb-32f741b509b1-retina-large.jpeg" },
  { name: "Fruity Pebbles Shake", price: "$6.44", desc: "Vanilla shake, cereal milk vibes, whipped top.", image: "https://www.studiomediaagency.com/marketing/donuts-marketing3.webp" },
  { name: "Strawberry Lemonade", price: "$5.78", desc: "Zesty lemonade with fresh strawberry pieces.", image: "https://www.studiomediaagency.com/marketing/donuts-marketing5.webp" },
  { name: "Iced Matcha Latte", price: "$6.44", desc: "Premium matcha + cold milk. Cool, calm, energized.", image: "https://img.cdn4dd.com/p/fit=cover,width=1200,height=1200,format=auto,quality=70/media/photosV2/4ead35c1-a529-4f24-b376-addab2d0353e-retina-large.jpeg" },
];

export const TESTIMONIALS = [
  { name: "Victoria R.", source: "DoorDash", text: "best donuts in the 956 😍", rating: 5 },
  { name: "Alejandro Y.", source: "DoorDash", text: "best donuts ever 👌", rating: 5 },
  { name: "G G.", source: "DoorDash", text: "First time trying it and wow!!! Chocolate Strawberry Donut was a 10/10 amazing!!", rating: 5 },
  { name: "Local foodie", source: "Grubhub", text: "Sweet, fluffy, and the kolache slaps. Don Donuts is a McAllen must.", rating: 5 },
  { name: "Sunday regular", source: "In-store", text: "The Don with a Nutella Frappé is the perfect weekend.", rating: 5 },
];

export const LOCATIONS = [
  {
    city: "McAllen",
    address: "101 E Expressway 83",
    cityState: "McAllen, TX 78501",
    phone: "(956) 502-7221",
    hours: "Mon – Sun · 7:00 AM – 7:00 PM",
    mapsEmbed: "https://www.google.com/maps?q=101+E+Expressway+83+McAllen+TX+78501&output=embed",
    mapsLink: "https://maps.google.com/?q=101+E+Expressway+83+McAllen+TX+78501",
  },
  {
    city: "San Juan",
    address: "1208 N Raul Longoria Rd",
    cityState: "San Juan, TX 78589",
    phone: "(956) 502-7221",
    hours: "Mon – Sun · 7:00 AM – 7:00 PM",
    mapsEmbed: "https://www.google.com/maps?q=1208+N+Raul+Longoria+Rd+San+Juan+TX&output=embed",
    mapsLink: "https://maps.google.com/?q=1208+N+Raul+Longoria+Rd+San+Juan+TX",
  },
];
